import { render, staticRenderFns } from "./Address-Editor.vue?vue&type=template&id=3e3ef2bc&"
import script from "./Address-Editor.vue?vue&type=script&lang=js&"
export * from "./Address-Editor.vue?vue&type=script&lang=js&"
import style0 from "./Address-Editor.vue?vue&type=style&index=0&id=3e3ef2bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports